export { default as Statement } from './containers/StatementContainer'



// WEBPACK FOOTER //
// ./src/Statement/index.js